export default "__VITE_ASSET__CtfXsL8c__"